export default function isLayerChecked(layerId, checkedLayers) {
  const id = String(layerId);
  return checkedLayers.includes(id);
}
